import React, { useEffect } from 'react';
import commonStyles from '../Point.module.scss';
import Title from '../../shared/Title/Title';
import Table from './Table/Table';
import { getTranslation } from '../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import { getTerminals } from '../../../store/actions/terminals';
import ContentSpinner from '../../shared/Spinner/Spinner';

export default function Terminals() {
    const dispatch = useDispatch();
    const { terminals, isFetching } = useSelector(state => state.terminals);

    useEffect(() => {
        dispatch(getTerminals());
    }, []);

    return (
        <>
            <Title title={getTranslation(`title.terminals`)} />
            <main className={commonStyles.main} style={{ height: 'calc(100% - 55px)' }}>
                {isFetching ? <ContentSpinner /> : <Table terminals={terminals} />}
            </main>
        </>
    );
}
